<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8048_32227)">
      <path d="M17.375 11.6602C17.175 11.6402 16.975 11.6202 16.775 11.5802C15.535 11.3602 14.375 10.8002 13.435 9.94016C10.695 7.83016 7.425 5.17016 5.755 2.16016H5.405C3.955 2.16016 3.045 3.72016 3.755 4.98016C5.075 7.31016 6.935 9.29015 9.175 10.7502C9.935 11.3402 13.7207 13.6189 14.6807 13.6189L17.375 11.6602Z"
            fill="url(#paint0_radial_8048_32227)"
      />
      <path d="M17.375 11.6602C17.175 11.6402 16.975 11.6202 16.775 11.5802C15.535 11.3602 14.375 10.8002 13.435 9.94016C10.695 7.83016 7.425 5.17016 5.755 2.16016H5.405C3.955 2.16016 3.045 3.72016 3.755 4.98016C5.075 7.31016 6.935 9.29015 9.175 10.7502C9.935 11.3402 13.7207 13.6189 14.6807 13.6189L17.375 11.6602Z"
            fill="url(#paint1_radial_8048_32227)"
      />
      <path d="M16.2047 7.37038L16.3808 8.60895L14.8174 9.80452L9.79688 2.15039H11.9747C12.6447 2.15039 13.2647 2.50038 13.5947 3.08038L16.2047 7.37038Z"
            fill="url(#paint2_linear_8048_32227)"
      />
      <path d="M19.2821 8.65603L17.6118 11.6702H20.255C21.225 11.6702 19.495 12.8964 20.255 12.3064C22.712 11.2751 27.025 7.32016 28.335 4.99016C29.055 3.72016 28.135 2.16016 26.695 2.16016H26.345C24.1527 4.44949 21.6202 6.74536 19.2821 8.65603Z"
            fill="url(#paint3_linear_8048_32227)"
      />
      <path d="M16.0147 11.6291C15.918 11.6411 15.8214 11.6507 15.7247 11.6604L15.5247 11.9004L15.7347 11.5732C14.5098 11.3483 13.3646 10.7911 12.4347 9.9404C9.69473 7.8304 7.21687 5.16039 5.54688 2.15039H9.93472L16.0147 11.6291Z"
            fill="url(#paint4_linear_8048_32227)"
      />
      <path d="M16.0147 11.6291C15.918 11.6411 15.8214 11.6507 15.7247 11.6604L15.5247 11.9004L15.7347 11.5732C14.5098 11.3483 13.3646 10.7911 12.4347 9.9404C9.69473 7.8304 7.21687 5.16039 5.54688 2.15039H9.93472L16.0147 11.6291Z"
            fill="url(#paint5_linear_8048_32227)"
      />
      <path d="M16.6086 10.211L16.7892 11.4809C17.8534 11.2143 18.8431 10.6918 19.6647 9.94016C22.4047 7.83016 24.6747 5.17016 26.3447 2.16016H21.7747L16.6086 10.211Z"
            fill="url(#paint6_linear_8048_32227)"
      />
      <path d="M16.6086 10.211L16.7892 11.4809C17.8534 11.2143 18.8431 10.6918 19.6647 9.94016C22.4047 7.83016 24.6747 5.17016 26.3447 2.16016H21.7747L16.6086 10.211Z"
            fill="url(#paint7_linear_8048_32227)"
      />
      <path d="M16.4208 11.6601H16.3745L16.5747 11.9002L16.4208 11.6601Z"
            fill="url(#paint8_linear_8048_32227)"
      />
      <path d="M16.4208 11.6601H16.3745L16.5747 11.9002L16.4208 11.6601Z"
            fill="url(#paint9_linear_8048_32227)"
      />
      <path d="M22.1549 2.16016H20.1149C19.4449 2.16016 18.8349 2.51016 18.4949 3.09016L13.2749 11.6702H16.0549L22.1549 2.16016Z"
            fill="url(#paint10_linear_8048_32227)"
      />
      <path d="M22.1549 2.16016H20.1149C19.4449 2.16016 18.8349 2.51016 18.4949 3.09016L13.2749 11.6702H16.0549L22.1549 2.16016Z"
            fill="url(#paint11_linear_8048_32227)"
      />
      <path d="M16.0371 30.0942C21.582 30.0942 26.0771 25.4872 26.0771 19.8042C26.0771 14.1212 21.582 9.51416 16.0371 9.51416C10.4921 9.51416 5.99707 14.1212 5.99707 19.8042C5.99707 25.4872 10.4921 30.0942 16.0371 30.0942Z"
            fill="url(#paint12_linear_8048_32227)"
      />
      <path d="M16.0371 30.0942C21.582 30.0942 26.0771 25.4872 26.0771 19.8042C26.0771 14.1212 21.582 9.51416 16.0371 9.51416C10.4921 9.51416 5.99707 14.1212 5.99707 19.8042C5.99707 25.4872 10.4921 30.0942 16.0371 30.0942Z"
            fill="url(#paint13_linear_8048_32227)"
      />
      <path d="M16.0371 28.2443C20.5824 28.2443 24.2671 24.4655 24.2671 19.8043C24.2671 15.143 20.5824 11.3643 16.0371 11.3643C11.4918 11.3643 7.80713 15.143 7.80713 19.8043C7.80713 24.4655 11.4918 28.2443 16.0371 28.2443Z"
            fill="url(#paint14_linear_8048_32227)"
      />
      <path d="M16.0371 28.2443C20.5824 28.2443 24.2671 24.4655 24.2671 19.8043C24.2671 15.143 20.5824 11.3643 16.0371 11.3643C11.4918 11.3643 7.80713 15.143 7.80713 19.8043C7.80713 24.4655 11.4918 28.2443 16.0371 28.2443Z"
            fill="url(#paint15_radial_8048_32227)"
      />
      <path d="M16.0371 28.2443C20.5824 28.2443 24.2671 24.4655 24.2671 19.8043C24.2671 15.143 20.5824 11.3643 16.0371 11.3643C11.4918 11.3643 7.80713 15.143 7.80713 19.8043C7.80713 24.4655 11.4918 28.2443 16.0371 28.2443Z"
            fill="url(#paint16_radial_8048_32227)"
      />
      <path d="M16.0468 28.8543C13.6868 28.8543 11.4668 27.9143 9.8068 26.2043C8.1368 24.4943 7.2168 22.2243 7.2168 19.8043C7.2168 17.3843 8.1368 15.1143 9.8068 13.4043C13.2468 9.87434 18.8468 9.87434 22.2968 13.4043C25.7368 16.9343 25.7368 22.6743 22.2968 26.2043C20.6168 27.9143 18.3968 28.8543 16.0468 28.8543ZM16.0368 11.9843C14.0868 11.9843 12.1268 12.7443 10.6468 14.2743C9.2068 15.7543 8.4168 17.7143 8.4168 19.8043C8.4168 21.8943 9.2068 23.8543 10.6468 25.3343C12.0868 26.8143 14.0068 27.6243 16.0368 27.6243C18.0768 27.6243 19.9868 26.8143 21.4268 25.3343C24.3968 22.2843 24.3968 17.3243 21.4268 14.2743C19.9468 12.7443 17.9968 11.9843 16.0368 11.9843Z"
            fill="url(#paint17_linear_8048_32227)"
      />
      <path d="M16.6472 15.7543L17.4772 17.4743C17.5772 17.6743 17.7672 17.8243 17.9872 17.8543L19.8372 18.1343C20.3872 18.2143 20.6172 18.9143 20.2072 19.3143L18.9272 20.5943C18.7372 20.7843 18.6772 21.0642 18.7572 21.3242L19.3472 23.0343C19.5472 23.6043 18.9872 24.1443 18.4372 23.9043L16.2972 22.9443C16.1272 22.8643 15.9272 22.8643 15.7572 22.9443L13.6172 23.9043C13.0772 24.1443 12.5072 23.6043 12.7072 23.0343L13.2972 21.3242C13.3872 21.0642 13.3172 20.7843 13.1272 20.5943L11.8472 19.3143C11.4472 18.9143 11.6672 18.2143 12.2172 18.1343L14.0672 17.8543C14.2872 17.8243 14.4772 17.6843 14.5772 17.4743L15.4072 15.7543C15.6772 15.2343 16.3972 15.2343 16.6472 15.7543Z"
            fill="url(#paint18_linear_8048_32227)"
      />
      <path d="M16.6472 15.7543L17.4772 17.4743C17.5772 17.6743 17.7672 17.8243 17.9872 17.8543L19.8372 18.1343C20.3872 18.2143 20.6172 18.9143 20.2072 19.3143L18.9272 20.5943C18.7372 20.7843 18.6772 21.0642 18.7572 21.3242L19.3472 23.0343C19.5472 23.6043 18.9872 24.1443 18.4372 23.9043L16.2972 22.9443C16.1272 22.8643 15.9272 22.8643 15.7572 22.9443L13.6172 23.9043C13.0772 24.1443 12.5072 23.6043 12.7072 23.0343L13.2972 21.3242C13.3872 21.0642 13.3172 20.7843 13.1272 20.5943L11.8472 19.3143C11.4472 18.9143 11.6672 18.2143 12.2172 18.1343L14.0672 17.8543C14.2872 17.8243 14.4772 17.6843 14.5772 17.4743L15.4072 15.7543C15.6772 15.2343 16.3972 15.2343 16.6472 15.7543Z"
            fill="url(#paint19_radial_8048_32227)"
      />
    </g>
    <defs>
      <radialGradient id="paint0_radial_8048_32227"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(10.4419 5.86532) rotate(124.323) scale(6.48778 12.8773)"
      >
        <stop offset="0.360874"
              stop-color="#3FA0F7"
        />
        <stop offset="1"
              stop-color="#2F60C2"
        />
      </radialGradient>
      <radialGradient id="paint1_radial_8048_32227"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(10.7342 12.2678) rotate(-90) scale(3.22394 3.90129)"
      >
        <stop stop-color="#3258BF" />
        <stop offset="1"
              stop-color="#3258BF"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint2_linear_8048_32227"
                      x1="11.3242"
                      y1="2.15039"
                      x2="16.3808"
                      y2="9.80452"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F53F56" />
        <stop offset="1"
              stop-color="#EA3586"
        />
      </linearGradient>
      <linearGradient id="paint3_linear_8048_32227"
                      x1="25.661"
                      y1="3.87383"
                      x2="25.1478"
                      y2="10.387"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FD4058" />
        <stop offset="1"
              stop-color="#F62E9E"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_8048_32227"
                      x1="13.3069"
                      y1="2.99651"
                      x2="7.76436"
                      y2="11.7007"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E3D4F3" />
        <stop offset="1"
              stop-color="#E3C2F5"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_8048_32227"
                      x1="13.9096"
                      y1="1.81108"
                      x2="13.9096"
                      y2="3.47068"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D3CCD9" />
        <stop offset="1"
              stop-color="#D3CCD9"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_8048_32227"
                      x1="23.4895"
                      y1="3.00541"
                      x2="17.7659"
                      y2="11.2554"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E3D4F3" />
        <stop offset="1"
              stop-color="#E3C2F5"
        />
      </linearGradient>
      <linearGradient id="paint7_linear_8048_32227"
                      x1="24.0422"
                      y1="1.8212"
                      x2="24.0422"
                      y2="3.47909"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D3CCD9" />
        <stop offset="1"
              stop-color="#D3CCD9"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint8_linear_8048_32227"
                      x1="23.4895"
                      y1="3.00541"
                      x2="17.7659"
                      y2="11.2554"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E3D4F3" />
        <stop offset="1"
              stop-color="#E3C2F5"
        />
      </linearGradient>
      <linearGradient id="paint9_linear_8048_32227"
                      x1="24.0422"
                      y1="1.8212"
                      x2="24.0422"
                      y2="3.47909"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D3CCD9" />
        <stop offset="1"
              stop-color="#D3CCD9"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint10_linear_8048_32227"
                      x1="20.9306"
                      y1="2.71265"
                      x2="16.3056"
                      y2="10.8376"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3EA0F4" />
        <stop offset="1"
              stop-color="#437EE0"
        />
      </linearGradient>
      <linearGradient id="paint11_linear_8048_32227"
                      x1="15.0932"
                      y1="7.31836"
                      x2="16.0468"
                      y2="7.95407"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6C65C0" />
        <stop offset="1"
              stop-color="#6C65C0"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint12_linear_8048_32227"
                      x1="21.4037"
                      y1="16.1567"
                      x2="13.3412"
                      y2="29.7817"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F4C654" />
        <stop offset="1"
              stop-color="#DC9729"
        />
      </linearGradient>
      <linearGradient id="paint13_linear_8048_32227"
                      x1="12.5287"
                      y1="30.5942"
                      x2="14.9037"
                      y2="17.1567"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FA8547" />
        <stop offset="1"
              stop-color="#FA8547"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint14_linear_8048_32227"
                      x1="12.2326"
                      y1="18.7339"
                      x2="24.5095"
                      y2="18.7339"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAA945" />
        <stop offset="1"
              stop-color="#EC9936"
        />
      </linearGradient>
      <radialGradient id="paint15_radial_8048_32227"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.2281 19.8043) rotate(180) scale(10.9797 9.59463)"
      >
        <stop offset="0.843882"
              stop-color="#F7B44D"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#F7B44D"
        />
      </radialGradient>
      <radialGradient id="paint16_radial_8048_32227"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.9004 19.8043) scale(10.3667 9.34393)"
      >
        <stop offset="0.826283"
              stop-color="#D2801F"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#D2801F"
        />
      </radialGradient>
      <linearGradient id="paint17_linear_8048_32227"
                      x1="24.0922"
                      y1="18.2244"
                      x2="16.0468"
                      y2="18.2244"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F9A842" />
        <stop offset="1"
              stop-color="#FAA742"
        />
        <stop offset="1"
              stop-color="#FAA742"
        />
      </linearGradient>
      <linearGradient id="paint18_linear_8048_32227"
                      x1="15.082"
                      y1="19.0748"
                      x2="18.4006"
                      y2="24.2418"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#864B60" />
        <stop offset="1"
              stop-color="#5D3247"
        />
      </linearGradient>
      <radialGradient id="paint19_radial_8048_32227"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.4038 16.9068) rotate(130.746) scale(2.68113 3.65655)"
      >
        <stop offset="0.200652"
              stop-color="#602543"
        />
        <stop offset="1"
              stop-color="#602543"
              stop-opacity="0"
        />
      </radialGradient>
      <clipPath id="clip0_8048_32227">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
